import * as fingerpose from 'fingerpose';

//one Finger for Page one
const oneFingerGesture = new fingerpose.GestureDescription('one_finger');
oneFingerGesture.addCurl(
  fingerpose.Finger.Index,
  fingerpose.FingerCurl.NoCurl,
  1.0
);
oneFingerGesture.addCurl(
  fingerpose.Finger.Thumb,
  fingerpose.FingerCurl.FullCurl,
  1.0
);
oneFingerGesture.addCurl(
  fingerpose.Finger.Middle,
  fingerpose.FingerCurl.FullCurl,
  1.0
);
oneFingerGesture.addCurl(
  fingerpose.Finger.Ring,
  fingerpose.FingerCurl.FullCurl,
  1.0
);
oneFingerGesture.addCurl(
  fingerpose.Finger.Pinky,
  fingerpose.FingerCurl.FullCurl,
  1.0
);

//three fingers for page three
const threeFingerGesture = new fingerpose.GestureDescription('three_fingers');

threeFingerGesture.addCurl(fingerpose.Finger.Thumb, fingerpose.FingerCurl.FullCurl, 1.0);
threeFingerGesture.addDirection(fingerpose.Finger.Thumb, fingerpose.FingerDirection.VerticalUp, 1.0);
threeFingerGesture.addDirection(fingerpose.Finger.Thumb, fingerpose.FingerDirection.DiagonalUpLeft, 1.0);

// index:
threeFingerGesture.addCurl(fingerpose.Finger.Index, fingerpose.FingerCurl.NoCurl, 1.0);
threeFingerGesture.addDirection(fingerpose.Finger.Index, fingerpose.FingerDirection.VerticalUp, 1.0);
threeFingerGesture.addDirection(fingerpose.Finger.Index, fingerpose.FingerDirection.DiagonalUpLeft, 1.0);

// middle:
threeFingerGesture.addCurl(fingerpose.Finger.Middle, fingerpose.FingerCurl.NoCurl, 1.0);
threeFingerGesture.addDirection(fingerpose.Finger.Middle, fingerpose.FingerDirection.VerticalUp, 1.0);
threeFingerGesture.addDirection(fingerpose.Finger.Middle, fingerpose.FingerDirection.DiagonalUpLeft, 1.0);

// ring:
threeFingerGesture.addCurl(fingerpose.Finger.Ring, fingerpose.FingerCurl.NoCurl, 1.0);
threeFingerGesture.addDirection(fingerpose.Finger.Ring, fingerpose.FingerDirection.VerticalUp, 1.0);
threeFingerGesture.addDirection(fingerpose.Finger.Ring, fingerpose.FingerDirection.DiagonalUpLeft, 1.0);
threeFingerGesture.addDirection(fingerpose.Finger.Ring, fingerpose.FingerDirection.HorizontalLeft, 1.0);

// pinky:
threeFingerGesture.addCurl(fingerpose.Finger.Pinky, fingerpose.FingerCurl.FullCurl, 1.0);
threeFingerGesture.addDirection(fingerpose.Finger.Pinky, fingerpose.FingerDirection.VerticalUp, 1.0);
threeFingerGesture.addDirection(fingerpose.Finger.Pinky, fingerpose.FingerDirection.DiagonalUpLeft, 1.0);
threeFingerGesture.addDirection(fingerpose.Finger.Pinky, fingerpose.FingerDirection.HorizontalLeft, 1.0);

// give additional weight to index, middle and ring fingers
threeFingerGesture.setWeight(fingerpose.Finger.Index, 2);
threeFingerGesture.setWeight(fingerpose.Finger.Middle, 2);
threeFingerGesture.setWeight(fingerpose.Finger.Ring, 2);

export const GE = new fingerpose.GestureEstimator([
  fingerpose.Gestures.VictoryGesture,
  fingerpose.Gestures.ThumbsUpGesture,
  oneFingerGesture,
  threeFingerGesture
]);
